import i18n from "../../i18n";
import {
  UPDATE_TIME
} from "./constants";
import { LOGOUT } from "../login/constants";
import moment from "moment";
import { IGeneralReducer } from "./types";

const initialState: IGeneralReducer = {
  time: moment().toDate(),
};

const reducer = function signupReducer(
  state: IGeneralReducer = initialState,
  action,
): IGeneralReducer {
  switch (action.type) {
    case UPDATE_TIME:
      {
        return {
          ...state,
          time: action.payload,
        };
      }

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
